// External Imports
import { connectRouter } from 'connected-react-router';
import reduceReducers from 'reduce-reducers';
import { combineReducers } from 'redux';

import { defaultState } from '../config/defaultState.mjs';
import { RECEIVE_PRIMARY_CONTENT, RECEIVE_SITE_OPTIONS } from '../config/types/action.mjs';
import { activeReducer } from './activeReducer.mjs';
import { archiveReducer } from './archiveReducer.mjs';
import { combineEntityReducers } from './combineEntityReducers.mjs';
import { createContentGroupReducer } from './createContentGroupReducer.mjs';
import { createOptionReducer } from './createOptionReducer.mjs';
import { featureFlagReducer } from './featureFlagReducer.mjs';
import { landingPageReducer } from './landingPageReducer.mjs';
import { menuReducer } from './menuReducer.mjs';
import { redirectReducer } from './redirectReducer.mjs';
import { siteOptionsErrorReducer } from './siteOptionsErrorReducer.mjs';
// Internal Imports
import { statsigExperimentReducer } from './statsigExperimentReducer.mjs';
import { userReducer } from './userReducer.mjs';

// Local Functions
function createRootReducer(history) {
  const sliceReducers = combineReducers({
    active: (state = defaultState.active) => state,
    archive: (state = defaultState.archive) => state,
    contentItem: createContentGroupReducer('contentType'),
    featureFlags: featureFlagReducer,
    landingPage: (state = defaultState.landingPage) => state,
    languagePicker: createOptionReducer('languagePicker'),
    languages: createOptionReducer('languages'),
    menu: menuReducer,
    redirect: redirectReducer,
    router: connectRouter(history),
    siteOptionsError: siteOptionsErrorReducer,
    socialMedia: createOptionReducer('socialMedia'),
    statsigExperiment: statsigExperimentReducer,
    term: createContentGroupReducer('taxonomy'),
    translations: createOptionReducer('translations'),
    user: userReducer,
    ...combineEntityReducers({
      author: RECEIVE_PRIMARY_CONTENT,
      contentType: RECEIVE_SITE_OPTIONS,
      footer: RECEIVE_SITE_OPTIONS,
      info: RECEIVE_SITE_OPTIONS,
      taxonomy: RECEIVE_SITE_OPTIONS,
    }),
  });
  return reduceReducers(sliceReducers, archiveReducer, landingPageReducer, activeReducer);
}

// Module Exports
export { createRootReducer };
